<template>
  <el-color-picker
    v-bind="$attrs"
    v-on="$listeners"
  ></el-color-picker>
</template>

<script>
export default {
  name: 'RtColorPicker'
};
</script>



// WEBPACK FOOTER //
// rtColorPicker.vue?32320aef